const MODULE_NAME = "oncall/";

//partners list
export const PARTNERS_PAGE_LOAD = `@@${MODULE_NAME}PARTNERS_PAGE_LOAD`;
export const PARTNERS_LOADED = `@@${MODULE_NAME}PARTNERS_LOADED`;

//edit partner
export const PARTNER_PAGE_LOAD = `@@${MODULE_NAME}PARTNER_PAGE_LOAD`;
export const PARTNER_PAGE_LOADED = `@@${MODULE_NAME}PARTNER_PAGE_LOADED`;
export const PARTNER_UPDATE_REQUEST = `@@${MODULE_NAME}PARTNER_UPDATE_REQUEST`;
export const PARTNER_UPDATED = `@@${MODULE_NAME}PARTNER_UPDATED`;
export const PARTNER_UPDATE_ERROR = `@@${MODULE_NAME}PARTNER_UPDATE_ERROR`;
export const PARTNER_ADD_REQUEST = `@@${MODULE_NAME}PARTNER_ADD_REQUEST`;
export const PARTNER_ADD_ERROR = `@@${MODULE_NAME}PARTNER_ADD_ERROR`;

//add queue for partner
export const PARTNER_QUEUE_ADD_REQUEST = `@@${MODULE_NAME}PARTNER_QUEUE_ADD_REQUEST`;
export const PARTNER_QUEUE_ADD_ERROR = `@@${MODULE_NAME}PARTNER_QUEUE_ADD_ERROR`;
export const PARTNER_QUEUE_ADDED = `@@${MODULE_NAME}PARTNER_QUEUE_ADDED`;
export const PARTNER_QUEUE_DELETE_REQUEST = `@@${MODULE_NAME}PARTNER_QUEUE_DELETE_REQUEST`;
export const PARTNER_QUEUE_DELETE_ERROR = `@@${MODULE_NAME}PARTNER_QUEUE_DELETE_ERROR`;
export const PARTNER_QUEUE_DELETED = `@@${MODULE_NAME}PARTNER_QUEUE_DELETED`;

export const PARTNER_LOGO_UPLOAD_REQUEST = `@@${MODULE_NAME}PARTNER_LOGO_UPLOAD_REQUEST`;
export const PARTNER_LOGO_UPLOADED = `@@${MODULE_NAME}PARTNER_LOGO_UPLOADED`;
export const PARTNER_LOGO_UPLOAD_ERROR = `@@${MODULE_NAME}PARTNER_LOGO_UPLOAD_ERROR`;
export const PARTNER_LOGO_DELETE_REQUEST = `@@${MODULE_NAME}PARTNER_LOGO_DELETE_REQUEST`;
export const PARTNER_LOGO_DELETE_ERROR = `@@${MODULE_NAME}PARTNER_LOGO_DELETE_ERROR`;
export const PARTNER_LOGO_DELETED = `@@${MODULE_NAME}PARTNER_LOGO_DELETED`;
export const PARTNER_LOGO_LOAD = `@@${MODULE_NAME}PARTNER_LOGO_LOAD`;
export const PARTNER_LOGO_LOADED = `@@${MODULE_NAME}PARTNER_LOGO_LOADED`;
export const PARTNER_LOGO_LOAD_ERROR = `@@${MODULE_NAME}PARTNER_LOGO_LOAD_ERROR`;

// Creators for partners list
export const partnersPageLoad = () => ({
  type: PARTNERS_PAGE_LOAD,
  payload: {},
});

export const partnersLoaded = partners => ({
  type: PARTNERS_LOADED,
  payload: {
    partners,
  },
});

// Creators for add and edit partner
export const partnerPageLoad = partnerId => ({
  type: PARTNER_PAGE_LOAD,
  payload: { partnerId },
});

export const partnerPageLoaded = partner => ({
  type: PARTNER_PAGE_LOADED,
  payload: {
    partner,
  },
});
export const partnerAddRequest = formData => ({
  type: PARTNER_ADD_REQUEST,
  payload: {
    formData,
  },
});
export const partnerAddError = message => ({
  type: PARTNER_ADD_ERROR,
  payload: {
    message,
  },
});
export const partnerUpdateRequest = (partnerId, formData) => ({
  type: PARTNER_UPDATE_REQUEST,
  payload: {
    partnerId,
    formData,
  },
});
export const partnerUpdated = () => ({
  type: PARTNER_UPDATED,
  payload: {},
});
export const partnerUpdateError = message => ({
  type: PARTNER_UPDATE_ERROR,
  payload: {
    message,
  },
});

//Creators for add queue
export const partnerQueueAddError = message => ({
  type: PARTNER_QUEUE_ADD_ERROR,
  payload: {
    message,
  },
});
export const partnerQueueAddRequest = (partnerId, queue) => ({
  type: PARTNER_QUEUE_ADD_REQUEST,
  payload: {
    partnerId,
    queue,
  },
});
export const partnerQueueAdded = queue => ({
  type: PARTNER_QUEUE_ADDED,
  payload: {
    queue,
  },
});
export const partnerQueueDeleteRequest = (partnerId, queue) => ({
  type: PARTNER_QUEUE_DELETE_REQUEST,
  payload: {
    partnerId,
    queue,
  },
});
export const partnerQueueDeleteError = queue => ({
  type: PARTNER_QUEUE_DELETE_ERROR,
  payload: {
    queue,
  },
});
export const partnerQueueDeleted = queue => ({
  type: PARTNER_QUEUE_DELETED,
  payload: {
    queue,
  },
});
export const partnerLogoUploadRequest = (partnerId, formData) => ({
  type: PARTNER_LOGO_UPLOAD_REQUEST,
  payload: {
    partnerId,
    formData,
  },
});
export const partnerLogoUploaded = imgSrc => ({
  type: PARTNER_LOGO_UPLOADED,
  payload: {
    imgSrc,
  },
});
export const partnerLogoUploadError = message => ({
  type: PARTNER_LOGO_UPLOAD_ERROR,
  payload: {
    message,
  },
});
export const partnerLogoDeleteRequest = partnerId => ({
  type: PARTNER_LOGO_DELETE_REQUEST,
  payload: {
    partnerId,
  },
});
export const partnerLogoDeleted = () => ({
  type: PARTNER_LOGO_DELETED,
  payload: {},
});
export const partnerLogoDeleteError = message => ({
  type: PARTNER_LOGO_DELETE_ERROR,
  payload: {
    message,
  },
});
export const partnerLogoLoad = logoName => ({
  type: PARTNER_LOGO_LOAD,
  payload: {
    logoName,
  },
});

export const partnerLogoLoaded = logo => ({
  type: PARTNER_LOGO_LOADED,
  payload: {
    logo,
  },
});
export const partnerLogoLoadError = () => ({
  type: PARTNER_LOGO_LOAD_ERROR,
  payload: {},
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/actions/partners.js